import { render, staticRenderFns } from "./temas.vue?vue&type=template&id=888a0ef0&"
import script from "./temas.component.ts?vue&type=script&lang=ts&"
export * from "./temas.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports